import { auth } from '../../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { v4 as uuidv4 } from 'uuid';

const getSensitiveTools = (callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'GETTING_SENSITIVE_TOOLS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/sensitive-tools`, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'GETTING_SENSITIVE_TOOLS_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data || {});
            }
          } else {
            dispatch({
              type: 'GETTING_SENSITIVE_TOOLS_FAILED',
              payload: `Failed to fetch sensitive tools`,
            });
            if (typeof errCb === 'function') {
              errCb(`Failed to fetch sensitive tools`);
            }
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_SENSITIVE_TOOLS_FAILED',
            payload: `Failed to fetch sensitive tools`,
          });
          if (typeof errCb === 'function') {
            errCb(
              e?.response?.data?.message || `Failed to fetch sensitive tools`,
            );
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'GETTING_SENSITIVE_TOOLS_FAILED',
        payload: `Failed to fetch sensitive tools`,
      });
      if (typeof errCb === 'function') {
        errCb(`Failed to fetch sensitive tools`);
      }
    }
  };
};

export default getSensitiveTools;
